import { Route } from "react-router-dom";
import  React  from 'react';

//Static
const Home = React.lazy(() => import('../pages/home'));
const Terms = React.lazy(() => import('../pages/terms'));
const Privacy = React.lazy(() => import('../pages/privacy'));
const Contact = React.lazy(() => import('../pages/contact'));
const AboutUs = React.lazy(() => import('../pages/aboutus'));
const FAQ = React.lazy(() => import('../pages/FAQ'));
const MitoView = React.lazy(() => import('../pages/mitoview'));
const MitoViewArticle = React.lazy(() => import('../pages/mitoview/[slug]'));
const MitoViewUnsubscribe = React.lazy(() => import('../pages/mitoview/unsubscribe'));

//Auth
const Login = React.lazy(() => import('../pages/login/login'));
const SignUp = React.lazy(() => import('../pages/signup'));
const Activateaccount = React.lazy(() => import('../pages/activateaccount'));
const RegisterActivation = React.lazy(() => import('../pages/register-activation'));
const NotFound = React.lazy(() => import('../pages/notfound'));
const PasswordChange = React.lazy(() => import('../pages/passwordchange'));

//Overview
const Overview = React.lazy(() => import('../pages/overview'));
const CollectionAccount = React.lazy(() => import('../pages/overview/collectionaccount'));

//Supports
const Support = React.lazy(() => import('../pages/support'));
const SupportFaq = React.lazy(() => import('../pages/support/faq'));
const MyTickets = React.lazy(() => import('../pages/support/my-tickets'));
const MyTicketsDetails = React.lazy(() => import('../pages/support/my-tickets/[id]'));
const CreateTicket = React.lazy(() => import('../pages/support/create-ticket'));

//Settings
const Settings = React.lazy(() => import('../pages/settings'));

//Compliance
const Compliance = React.lazy(() => import('../pages/compliance/index'));

//Recipients
const Beneficiaries = React.lazy(() => import('../pages/beneficiaries'));
const Senders = React.lazy(() => import('../pages/senders'));
const BeneficiaryDetails = React.lazy(() => import('../pages/beneficiaries-details/[id]'));
const EditBeneficiary = React.lazy(() => import('../pages/beneficiaries/edit-beneficiary/[id]'));
const AddBeneficiaries = React.lazy(() => import('../pages/beneficiaries/add-beneficiaries'));

//NotFoundPage
const NotFoundPage = React.lazy(() => import('../pages/404'));

//Transactions
const Transactions = React.lazy(() => import('../pages/transactions'));
const TransactionDetails = React.lazy(() => import('../pages/transactions/transactiondetails/[id]'));
const ReceiveMoneyDetails = React.lazy(() => import('../pages/transactions/receive-money/[id]'));
const TransactionsSendmoney = React.lazy(() => import('../pages/transactions/sendmoney'));
const TransactionsAirtimetopup = React.lazy(() => import('../pages/transactions/airtimetopup'));
const TransactionsBillpayment = React.lazy(() => import('../pages/transactions/billpayment'));
const NotificationsInbox = React.lazy(() => import('../pages/notifications'));
const Rewards = React.lazy(() => import('../pages/rewards'));
const ReferralLanding = React.lazy(() => import('../pages/ref/[code]'));
const ReceiveMoney = React.lazy(() => import('../pages/receive-money'));
const RequestPayment = React.lazy(() => import('../pages/request-payment'));
const ReceiveMoneyPay = React.lazy(() => import('../pages/receive-money/pay'));
const SendInvoice = React.lazy(() => import('../pages/send-invoice'));
const Invoices = React.lazy(() => import('../pages/invoices'));
const ViewInvoice = React.lazy(() => import('../pages/sent-invoices/[id]'));


const Status = React.lazy(() => import('../pages/kyc/status'));
const Kyc = React.lazy(() => import('../pages/kyc'));
const KycReturn = React.lazy(() => import('../pages/kyc/KycReturn'));

const SendStatus = React.lazy(() => import('../pages/send/status'));
const StatusPaybybank = React.lazy(() => import('../pages/send/statuspaybybank'));
const CheckoutSuccess = React.lazy(() => import('../pages/send/success'));
const CheckoutFailed = React.lazy(() => import('../pages/send/failed'));

const Deactivated = React.lazy(() => import('../pages/domain-deactivated'));

export const publicRoutes = [
  {
    path: "/",
    element: <Home />
  },
  {
    path: "/login",
    element: <Login />
  },
  {
    path: "/signup",
    element: <SignUp />
  },
  {
    path: "/ref/:code",
    element: <ReferralLanding />
  },
  {
    path: "/activateaccount",
    element: <Activateaccount />
  },
  {
    path: "/register-activation",
    element: <RegisterActivation />
  },
  {
    path: "/notfound",
    element: <NotFound />
  },
  {
    path: "/passwordchange",
    element: <PasswordChange />
  },
  {
    path: "/terms",
    element: <Terms />
  },
  {
    path: "/privacy",
    element: <Privacy />
  },
  {
    path: "/contact",
    element: <Contact />
  },
  {
    path: "/aboutus",
    element: <AboutUs />
  },
  {
    path: "/FAQ",
    element: <FAQ />
  },
  {
    path: "/mitoview",
    element: <MitoView />
  },
  {
    path: "/mitoview/unsubscribe",
    element: <MitoViewUnsubscribe />
  },
  {
    path: "/mitoview/:slug",
    element: <MitoViewArticle />
  },
  {
    path: "/kyc/status",
    element: <Status />
  },
  {
    path: "/send/status",
    element: <SendStatus />
  },
  {
    path: "/send/statuspaybybank",
    element: <StatusPaybybank />
  },
  {
    path: "/send/success",
    element: <CheckoutSuccess />
  },
  {
    path: "/send/failed",
    element: <CheckoutFailed />
  },
  {
    path: "/journey/status",
    element: <SendStatus />
  },
  {
    path: "/success",
    element: <SendStatus />
  },
  {
    path: "/domain-deactivated",
    element: <Deactivated />
  },
  {
    path: "/kyc/return",
    element: <KycReturn />
  },
  {
    path: "/pay/:token",
    element: <ReceiveMoneyPay />
  },
].map((props, index) => <Route key={props.path || index} {...props} />);

export const notFoundRoute = (
  <Route key="not-found" path="*" element={<NotFoundPage />} />
);

export const privateRoutes = [
  {
    path: "/overview",
    element: <Overview />
  },
  {
    path: "/Overview",
    element: <Overview />
  },
  {
    path: "/support",
    element: <Support />
  },
  {
    path: "/support/faqs",
    element: <SupportFaq />
  },
  {
    path: "/support/my-tickets",
    element: <MyTickets />
  },
  {
    path: "/support/my-tickets/:id",
    element: <MyTicketsDetails />
  },
  {
    path: "/support/create-ticket",
    element: <CreateTicket />
  },
  {
    path: "/settings",
    element: <Settings />
  },
  {
    path: "/compliance",
    element: <Compliance />
  },
  {
    path: "/beneficiaries",
    element: <Beneficiaries />
  },
  {
    path: "/senders",
    element: <Senders />
  },
  {
    path: "/beneficiaries-details/:id",
    element: <BeneficiaryDetails />
  },
  {
    path: "/beneficiaries/add-beneficiaries",
    element: <AddBeneficiaries />
  },
  {
    path: "/beneficiaries/edit-beneficiary/:id",
    element: <EditBeneficiary />
  },
  {
    path: "/overview/collectionaccount",
    element: <CollectionAccount />
  },
  {
    path: "/transactions",
    element: <Transactions />
  },
  {
    path: "/transactions/transactiondetails/:id",
    element: <TransactionDetails />
  },
  {
    path: "/transactions/receive-money/:id",
    element: <ReceiveMoneyDetails />
  },
  {
    path: "/transactions/sendmoney",
    element: <TransactionsSendmoney />
  },
  {
    path: "/request-payment",
    element: <RequestPayment />
  },
  {
    path: "/receive-money",
    element: <ReceiveMoney />
  },
  {
    path: "/send-invoice",
    element: <SendInvoice />
  },
  {
    path: "/invoices",
    element: <Invoices />
  },
  {
    path: "/sent-invoices/:id",
    element: <ViewInvoice />
  },
  {
    path: "/transactions/airtimetopup",
    element: <TransactionsAirtimetopup />
  },
  {
    path: "/transactions/billpayment",
    element: <TransactionsBillpayment />
  },
  {
    path: "/notifications",
    element: <NotificationsInbox />
  },
  {
    path: "/rewards",
    element: <Rewards />
  },
  {
    path: "/kyc",
    element: <Kyc />
  },
].map((props, index) => <Route key={props.path || index} {...props} />);